const result = {
    possibleTypes: {
        Entity: [
            'BlobUserInteractions',
            'Conversation',
            'ConversationAlias',
            'ConversationParticipant',
            'EventUserInteractions',
            'FileRef',
            'IntakeUserInteractions',
            'MatterInvoiceUserInteractions',
            'Message',
            'MessageBlobRef',
            'PortalBlobRef',
            'SMSMetadata',
            'SharedConversationParticipant',
            'SystemMessage',
            'Team',
            'User',
            'UserMetadata',
        ],
    },
};
export default result;
